function PurchaseOrderStatusBadge({ status }) {
  const toneClassName =
    status === 'Completed'
      ? 'bg-[#edf5ee] text-[#4d7b56]'
      : status === 'Received'
        ? 'bg-[#edf3fb] text-[#4c6f99]'
        : status === 'Cancelled'
          ? 'bg-[#f8ece9] text-[#bb5745]'
          : status === 'In Progress'
            ? 'bg-[#fbf4e8] text-[#c28a2e]'
            : 'bg-[#ece9f6] text-[#6a5bb6]';

  return (
    <span
      className={`inline-flex items-center rounded-full px-3 py-1 text-[0.76rem] font-semibold uppercase tracking-[0.08em] ${toneClassName}`}
    >
      {status}
    </span>
  );
}

export default PurchaseOrderStatusBadge;
